import { render, staticRenderFns } from "./AddProgramInformation.vue?vue&type=template&id=c3ed300c&scoped=true"
import script from "./AddProgramInformation.vue?vue&type=script&lang=js"
export * from "./AddProgramInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ed300c",
  null
  
)

export default component.exports